<script setup lang="ts">
import type { ResponsivePropsType } from '@/components/goat/form/compositions/FieldsUtils'
import {
  ResponsivePropsDefaults

} from '@/components/goat/form/compositions/FieldsUtils'

interface Props {
  offset?: number
  justify?: 'start' | 'end' | 'center' | 'space-around' | 'space-between' | 'space-evenly'
  mobileRowBreak?: boolean
}

withDefaults(defineProps<Props & ResponsivePropsType>(), {
  ...ResponsivePropsDefaults,
  justify: 'start'
})
</script>

<template>
  <el-col
    :xs="xs"
    :sm="sm"
    :md="md"
    :lg="lg"
    :xl="xl"
    :offset="offset"
    v-bind="$attrs"
    class="px-2"
  >
    <el-row
      :justify="justify"
    >
      <slot />
    </el-row>
  </el-col>
</template>
